import React from 'react';
import Link from 'next/link';
import { useUserInfo } from '@repository/auth/useUserInfo';
import LoginModal from '@components/loginModal';
import { RouteUrl } from '@utils/routeUtil';
import useModal from '@utils/hooks/useModal';
import classnames from 'classnames/bind';
import styles from './floatingBtn.module.scss';
const cx = classnames.bind(styles);

const FloatingBtn = () => {
  const { data: userInfo } = useUserInfo();
  const isLogin = !!userInfo?.id;
  const { closeModal, isModalOpen, openModal } = useModal();

  return (
    <>
      <div className={cx('floatingBtn')}>
        <div className={cx('btnArea')}>
          <span className={cx('floatingMsg')}>
            지금 JOBDA matching 참여하고 <strong>입사제안 받으세요!</strong>
          </span>
          {isLogin ? (
            <Link href={RouteUrl.MATCH_APPLY} className={cx('btnBlack')}>
              매칭 참여하기
            </Link>
          ) : (
            <a role="button" className={cx('btnBlack')} onClick={openModal}>
              매칭 참여하기
            </a>
          )}
        </div>
      </div>

      <LoginModal
        subTitle="채용정보 · 역량검사 · 매칭까지"
        title="취업기회 지금 바로 잡다!"
        visible={isModalOpen}
        onClose={closeModal}
      />
    </>
  );
};

export default FloatingBtn;
